<script setup>
import { reactiveOmit } from "@vueuse/core";
import { Primitive } from "reka-ui";
import { cn } from "@/shared/lib/utils";
import { useActionBar } from "./context";

const props = defineProps({
  class: { type: [String, Object, Array], default: undefined },
  as: { type: [String, Object], default: "button" },
  asChild: { type: Boolean, default: false },
});

const delegatedProps = reactiveOmit(props, "class");
const { isOpen, close } = useActionBar();
</script>

<template>
  <Primitive
    v-bind="delegatedProps"
    type="button"
    aria-label="Close"
    data-slot="action-bar-close"
    :data-state="isOpen ? 'open' : 'closed'"
    :class="cn('opacity-60 transition-opacity hover:opacity-100', props.class)"
    @click="close"
  >
    <slot />
  </Primitive>
</template>
